import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1800Component } from './kymw1800.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetImageExistenceListService } from './api-services/get-image-existence-list.service';

/**
 * 画像ﾁｪｯｸﾘｽﾄ出力画面 モジュール設定クラス
 *
 * @export KYMW1800Module
 * @class KYMW1800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1800Component,
  ],
  providers: [
    GetImageExistenceListService
  ],
})
export class KYMW1800Module {

}
